export default __webpack_public_path__ + "static/media/kitchen5-beforeC-768w.63c998ff.png";